<template>
    <div class="columns is-centered">
        <div class="column is-narrow is-hidden-mobile"
             v-for="(weekday, idx) in weekdays"
             v-if="weekday"
             :key="idx"
             @click="changeActiveWeekday(idx)">
            <span class="weekday"
               :class="{ 'is-active-weekday': weekday === getActiveWeekDay }">
                {{ weekday }} [{{  getDateOfDay(idx) }}]
            </span>
        </div>

        <div class="column is-hidden-desktop">
            <div class="select is-fullwidth">
                <select v-model="selected" @change="changeActiveWeekday(selected)">
                    <option v-for="(day, idx) in weekdays"
                            v-if="day"
                            :selectd="selected === day"
                            v-bind:value="idx">
                        {{ day }}
                    </option>
                </select>
            </div>
        </div>

    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        data() {
            return {
                weekdays: [
                    '',
                    'MONDAY',
                    'TUESDAY',
                    'WEDNESDAY',
                    'THURSDAY',
                    'FRIDAY',
                    'SATURDAY'
                ],
                selected: ''
            }
        },
        mounted() {
            const day = new Date().getDay()
            this.selected = day === 0 ? day + 1 : day
            this.$store.dispatch('changeActiveWeekday', this.weekdays[this.selected])
        },
        computed: {
            getActiveWeekDay() {
                return this.$store.getters.getActiveWeekday
            }
        },
        methods: {
            changeActiveWeekday(val) {
                this.$store.dispatch('changeActiveWeekday', this.weekdays[val])
            },
            getDateOfDay(day) {
                const d = new Date();
                if (d.getDay() === day) {
                    return moment().format('MM.DD')
                }else if (d.getDay() < day) {
                    const diffMore =  d.getDay() - day
                    return moment().subtract(diffMore, 'day').format('MM.DD')
                }else {
                    const diffLess =  d.getDay() + day - 1
                    return moment().add(diffLess, 'day').format('MM.DD')
                }

            }
        }
    }
</script>

<style scoped>
    .weekday {
        color: grey;
        cursor: pointer;
    }
    .is-active-weekday {
        color: #3273dc;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Locations/LocationsNavigation.vue